const searchForm = document.getElementById("searchForm");

if (searchForm) {
  searchForm.addEventListener("submit", function (event) {
    event.preventDefault();
    const searchInput = document.getElementById("keyword");
    const searchValue = searchInput && searchInput.value;
    console.log(searchValue);
    if (searchValue) {
      window.location.href = "/result/?keyword=" + searchValue;
    }
  });
}
